module.exports = __webpack_public_path__ + "AKL.3166fb50.json";